// @flow

// Types
import type { Action } from 'fc-flow-types/redux'
import type { Job } from 'fc-model-sampling-jobs/types'

// Action Types
import { REOPEN_JOB } from './constants'

// Actions
export const reopenJob = (job: Job): Action<> => ({
  type: REOPEN_JOB,
  job,
})
